import { defHttp } from "../utils/http/axios";

const Api = {
    /**
     * Project -- 管理
     */
    saveProject: "/cat/project/save",
    getProjectList: "/cat/project/list",
    getCurrentState: "/project/list/state",
    delProject: "/cat/project/delete",
    getProjectOverview: "/cat/project/overview",
    getProjectDetail: "/cat/project/detail",
    getProject: "/project/getProjectById",
    getProjectAutoRefreshStates: "/cat/project/state",
    getTaskDetail: "/project/myTasks",
    saveGroups: "/project/saveGroups",
    startProjectQaStat: "/cat/project/stats/startQa",
    startProjectPreStat: "/cat/project/stats/startPre",
    startProjectPostStat: "/cat/project/stats/startPost",
    getProjectAllStatStatus: "/cat/project/stats/status",
    changeAllProjectStats: "/project/changeAllProjectStats",
    getAvailableAiModelPackages: "/project/aiModelPackage/list",

    /**
     * Project -- 结项
     */
    checkIfAllFilesFinished: "/cat/project/file/allFinished",
    finishProject: "/cat/project/finish",

    /**
     * File
     */
    uploadProjectFile: "/cat/project/file/upload",
    getProjectTaskFiles: "/cat/project/file/list",
    getRecentFileStates: "/project/file/states",
    reprocessTaskFile: "/cat/project/file/reprocess",
    finishFile: "/cat/project/file/finish",
    backFile: "/cat/project/file/reopen",
    saveProjectFiles: "/cat/project/file/save",
    getFileStates: "/cat/project/file/states",
    getFileLogs: "/cat/project/file/log/list",
    delProjectFile: "/cat/project/file/delete",
    getFileCount: "/cat/project/file/count",


    /**
     * 导出
     */
    exportProject: "/cat/project/export",
    exportProjectFile: "/cat/project/file/export",

    /**
     * Sentence
     */
    getFileTus: "/cat/project/file/sentence/list",

    /**
     * TM
     */
    getUsedTM: "/cat/project/tm/list",
    addCopyTm: "/cat/project/tm/copy",
    addMergeTm: "/cat/project/tm/merge",
    getProjectMergeTms: "/tm/merges",
    getProjectTMs: "/cat/project/tm/tms",
    updateProjectMergeTmState: "/corpus/tm/combine/reStart",

    /**
     * TB
     */
    getUsedTB: "/cat/project/tb/list",
    getProjectGlossary: "/cat/project/tb/selected/one",

    /**
     * QA
     */
    getProjectQualityCheck: "/cat/project/checker/list",

    /**
     * 统计
     */
    getProjectStatsPretrans: "/cat/project/stats/pretrans",
    getProjectUsers: "/cat/project/stats/users",
    getProjectStatsPosttrans: "/cat/project/stats/posttrans",
    getProjectQaStatUser: "/cat/project/stats/qaUsers",
    getUserProjectStatsTypeQa: "/cat/project/stats/qa/type",
    getUserProjectStatsSubTypeQa: "/cat/project/stats/qa/subType",
    getQaStatsDetailSentences: "/cat/project/stats/qa/sentence",


    /**
     * task
     */
    getTaskDistribution: "/cat/project/file/task/distribution",
    saveSplitTaskSettings: "/cat/project/file/task/distribution/save",
    finishTask: "/cat/tasker/project/task/finish",
    rejectTask: "/cat/tasker/project/task/refuse",

    /**
     * tasker related
     */
    getTaskerProjectList: "/cat/tasker/project/list",
    getEntrustedProjectInfo: "/studentProject/task/project",
    getTaskerFiles: "/cat/tasker/project/file/list",

    /**
     * ai models
     */
    getProjectUsedAIModelPackages: "/cat/project/ai/model/selected",
    getAiAssistantList: "/cat/project/ai/assistant/list",
    getAiLexicalConstraintList: "/cat/project/ai/lexicalConstraint/list",

    /**
     * ate（术语提取）
     */
    extractTerm: "/cat/project/ate/extract",
    updateATEState: "/cat/project/ate/state/update",
    toGlossary: "/cat/project/ate/toGlossary",
    translateWithMT: "/cat/project/ate/translateWithMT",
}

/**
 * 创建或编辑项目时，上传附件
 * @param {Object} file
 * @returns
 */
export function uploadProjectFile(formData, timeout, options) {
    return defHttp.uploadCancellableFile({ url: Api.uploadProjectFile, timeout }, formData, {
        onUploadProgress(progress) {
            options.onUploadProgress(progress);
        },
    });
}

/**
 * 获取当前项目使用的 TM
 * @param {String} projectId
 * @returns
 */
export function getUsedTM(params) {
    return defHttp.get({ url: Api.getUsedTM, params });
}

/**
 * 获取当前项目使用的 TB
 * @param {String} id
 * @returns
 */
export function getUsedTB(params) {
    return defHttp.get({ url: Api.getUsedTB, params });
}

/**
 * 创建项目
 * @param {Object} form
 * @returns
 */
export function saveProject(data) {
    return defHttp.post({ url: Api.saveProject, data });
}

/**
 * 获取项目列表
 */
export function getProjectList(data) {
    return defHttp.post({ url: Api.getProjectList, data });
}

/**
 * 获取传入项目的字段最新值
 * @param {Object} form
 * @returns
 */
export function getCurrentState(data,cancelToken) {
    return defHttp.post({ url: Api.getCurrentState, data,cancelToken });
}

/**
 * 删除一个项目
 */
export function delProject(params) {
    return defHttp.post({ url: Api.delProject, params });
}

/**
 * 获取项目概览数据
 * @param {String} id
 * @returns
 */
export function getProjectOverview(params) {
    return defHttp.get({ url: Api.getProjectOverview, params });
}

/**
 * 获取项目详情，包括基本信息卡片/项目设置
 * @param {String} id
 * @returns
 */
export function getProjectDetail(params) {
    return defHttp.get({ url: Api.getProjectDetail, params });
}

/**
 * 项目详情：获取已上传的任务文件
 * @param {String} id
 * @returns
 */
export function getProjectTaskFiles(params) {
    return defHttp.get({ url: Api.getProjectTaskFiles, params });
}

/**
 * 获取文件们的最新状态
 * @param {Array} ids
 * @returns
 */
export function getRecentFileStates(data) {
    return defHttp.post({ url: Api.getRecentFileStates, data });
}

/**
 *
 * @param {String} id
 * @returns
 */
export function getProject(params) {
    return defHttp.get({ url: Api.getProject, params });
}

/**
 * 重新预处理
 * @param {String} id
 * @returns
 */
export function reprocessTaskFile(data) {
    return defHttp.post({ url: Api.reprocessTaskFile, data });
}

/**
 * 切换任务文件状态为完成
 * @param {String} id
 * @returns
 */
export function finishFile(params) {
    return defHttp.post({ url: Api.finishFile, params }, { isTransformResponse: false });
}

/**
 * 打回文件
 * @param {String} id
 * @returns
 */
export function backFile(params) {
    return defHttp.post({ url: Api.backFile, params });
}

/**
 * 保存用户上传的任务文件
 * @param {Object} form
 * @returns
 */
export function saveProjectFiles(data) {
    return defHttp.post({ url: Api.saveProjectFiles, data });
}

/**
 * 获得项目下文件们（仅状态字段和id）
 * @param {*} id
 * @returns
 */
export function getFileStates(params) {
    return defHttp.get({ url: Api.getFileStates, params });
}

/**
 * 获取项目下文件的数量
 * @param {*} id
 * @returns
 */
export function getFileCount(params) {
    return defHttp.get({ url: Api.getFileCount, params });
}


/**
 * 项目项目需要自动刷新的状态值集合
 * @param {String} id
 * @returns
 */
export function getProjectAutoRefreshStates(params) {
    return defHttp.get({ url: Api.getProjectAutoRefreshStates, params });
}

/**
 * 导出项目(zip)
 * @param {*} data
 * @returns
 */
export function exportProject(params) {
    return defHttp.get({ url: Api.exportProject, params });
}

/**
 * 导出项目任务文件
 * @param {*} params
 * @returns
 */
export function exportFile(params) {
    return defHttp.get({ url: Api.exportProjectFile, params });
}

/**
 * 获取文件日志
 * @param {*} params
 * @returns
 */
export function getFileLogs(data) {
    return defHttp.post({ url: Api.getFileLogs, data });
}

/**
 * 删除单个已上传的任务文件
 * @param {String} id
 * @returns
 */
export function delProjectFile(data) {
    return defHttp.post({ url: Api.delProjectFile, data });
}

/**
 *
 * @param {Object} form
 * @returns
 */
export function getTaskDetail(data) {
    return defHttp.post({ url: Api.getTaskDetail, data });
}

/**
 * 任务分配>左侧分配面板 + 右侧学生分组
 * @param {Number} taskId 该任务（即该文档）的ID
 */
export function getTaskDistribution(params) {
    return defHttp.get({ url: Api.getTaskDistribution, params });
}

/**
 *
 * @param {Object} form
 * @param {Array} form.groups - 学生分组
 * @param {String} form.id - 任务文件 ID
 * @param {String} form.projectId - 项目 ID
 * @returns
 */
export function saveGroups(data) {
    return defHttp.post({ url: Api.saveGroups, data });
}

/**
 * 任务分配>左侧分配面板 - 预览/浏览任务按钮
 * @param {String} fileId 文件id
 */
export function getFileTus(params) {
    return defHttp.get({ url: Api.getFileTus, params });
}

/**
 * 任务分配 - 左上角的保存按钮
 * @param {Number} taskId 该任务（即该文档）的ID
 * @param {Object[]} ranges 左侧面板各个行（子任务）的分配情况
 * @param {string} ranges[].id 子任务的 ID
 * @param {string} ranges[].rangeStart 子任务的下限
 * @param {string} ranges[].rangeEnd 子任务的上限
 *
 * @param {Object} ranges[].translate 翻译列
 * @param {String} ranges[].translate.progress 学生的翻译进度
 * @param {String} ranges[].translate.student 负责翻译的学生
 *
 * @param {Object} ranges[].review 审校列
 * @param {String} ranges[].review.progress 学生的审校进度
 * @param {String} ranges[].review.student 负责审校的学生
 *
 * @param {Object} ranges[].final 通读列
 * @param {String} ranges[].final.progress 学生的通读进度
 * @param {String} ranges[].final.student 负责通读的学生
 */
export function saveSplitTaskSettings(data) {
    return defHttp.post({ url: Api.saveSplitTaskSettings, data }, { isTransformResponse: false });
}

/**
 * 我的任务 - 获取用户负责的项目列表
 * @param {String} courseId 课程 ID
 * @returns
 */
export function getTaskerProjectList(data) {
    return defHttp.post({ url: Api.getTaskerProjectList, data });
}

/**
 * 获取学生负责项目的详情
 * @param {String} id
 * @returns
 */
export function getEntrustedProjectInfo(params) {
    return defHttp.get({ url: Api.getEntrustedProjectInfo, params });
}

/**
 * 我的任务 - 获取用户负责的某项目下，负责的任务列表
 * @param {String} projectId 项目 id
 * @returns
 */
export function getTaskerFilesByProjectId(params) {
    return defHttp.get({ url: Api.getTaskerFiles, params });
}

/**
 * 切换学生负责的单个任务状态为完成
 * @param {String} id
 * @returns
 */
export function finishTask(params) {
    return defHttp.post({ url: Api.finishTask, params }, { isTransformResponse: false });
}

/**
 * 学生拒绝选中的单个任务
 * @param {String} id
 * @returns
 */
export function rejectTask(params) {
    return defHttp.post({ url: Api.rejectTask, params });
}

/**
 * 项目详情：获取质量检查器和选项
 * @param {String} id
 * @returns
 */
export function getProjectQualityCheck(params) {
    return defHttp.get({ url: Api.getProjectQualityCheck, params });
}

/**
 * 得到项目的项目工作量统计
 * @param {String} id
 */
export function getProjectStatsPretrans(params) {
    return defHttp.get({ url: Api.getProjectStatsPretrans, params });
}
/**
 * 得到项目的统计用户列表
 * @param {String} id
 */
export function getProjectUsers(params) {
    return defHttp.get({ url: Api.getProjectUsers, params });
}
/**
 * 得到项目的任务人工作量统计
 * @param {String} id
 */
export function getProjectStatsPosttrans(data) {
    return defHttp.post({ url: Api.getProjectStatsPosttrans, data });
}

/**
 * 生成项目Qa统计
 * @param {String} id
 */
export function startProjectQaStat(params) {
    return defHttp.get({ url: Api.startProjectQaStat, params }, { isTransformResponse: false });
}

/**
 * 生成项目译前统计
 * @param {String} id
 */
export function startProjectPreStat(params) {
    return defHttp.get({ url: Api.startProjectPreStat, params }, { isTransformResponse: false });
}

/**
 * 生成项目译后统计
 * @param {String} id
 */
export function startProjectPostStat(params) {
    return defHttp.get({ url: Api.startProjectPostStat, params }, { isTransformResponse: false });
}

/**
 * 得到项目的Qa用户统计列表
 * @param {String} id
 */
export function getProjectQaStatUser(params) {
    return defHttp.get({ url: Api.getProjectQaStatUser, params });
}

/**
 * 得到项目的Qa大类统计
 */
export function getUserProjectStatsTypeQa(data) {
    return defHttp.post({ url: Api.getUserProjectStatsTypeQa, data });
}

/**
 * 得到项目的Qa小类统计
 */
export function getUserProjectStatsSubTypeQa(data) {
    return defHttp.post({ url: Api.getUserProjectStatsSubTypeQa, data });
}

/**
 * 得到项目的Qa小类统计
 */
export function getQaStatsDetailSentences(data) {
    return defHttp.post({ url: Api.getQaStatsDetailSentences, data });
}

/**
 * 得到项目不同类型统计的状态
 * @param {String} id
 */
export function getProjectAllStatStatus(params) {
    return defHttp.get({ url: Api.getProjectAllStatStatus, params });
}

/**
 * 给项目生成统计主数据(压力测试造数据使用)
 */
export function changeAllProjectStats() {
    return defHttp.post({ url: Api.changeAllProjectStats });
}

/**
 * 获得项目下的文件是否全部已完成
 * @param {*} id
 */
export function checkIfAllFilesFinished(params) {
    return defHttp.get({ url: Api.checkIfAllFilesFinished, params });
}

/**
 * 结项
 * @param {*} id
 */
export function finishProject(params) {
    return defHttp.post({ url: Api.finishProject, params }, { isTransformResponse: false });
}

/**
 * 转为新的库
 * @param {*} id
 */
export function addCopyTm(params) {
    return defHttp.get({ url: Api.addCopyTm, params });
}

/**
 * 临时库合并到引用库
 * @param {*} form
 */
export function addMergeTm(data) {
    return defHttp.post({ url: Api.addMergeTm, data });
}

/**
 * 根据源记忆库id得到复制和合并的记忆库合并信息
 * @param {*} id
 */
export function getProjectMergeTms(params) {
    return defHttp.get({ url: Api.getProjectMergeTms, params });
}

/**
 * 获取项目语言资产
 * @param {String} id
 * @returns
 */
export function getProjectTMs(params) {
    return defHttp.get({ url: Api.getProjectTMs, params });
}

export function updateProjectMergeTmState(data) {
    return defHttp.post({ url: Api.updateProjectMergeTmState, data });
}

/**
 * 提取术语
 * @param {*} data
 * @returns
 */
export function extractTerm(data){
    return defHttp.post({url:Api.extractTerm,data})
}

/**
 * 更新术语提取状态
 * @param {*} data
 */
export function updateATEState(data) {
    return defHttp.post({ url: Api.updateATEState, data });
}

/**
 * 获取单个项目术语库
 * @param {*} data
 * @returns
 */
export function getProjectGlossary(data) {
    return defHttp.post({ url: Api.getProjectGlossary, data });
}

/**
 * 获取项目下的可选GPT模型选项
 * @returns
 */
export function getAvailableAiModelPackages(params) {
    return defHttp.get({ url: Api.getAvailableAiModelPackages, params });
}

/**
 * 获取项目子模块使用的AI模型包
 * @param {String} id
 * @returns
 */
export function getProjectUsedAIModelPackages(params) {
    return defHttp.get({ url: Api.getProjectUsedAIModelPackages, params });
}

/**
 * 查询AI助手模型包列表
 * @returns
 */
export function getAiAssistantList(params) {
    return defHttp.get({ url: Api.getAiAssistantList, params });
}

/**
 * 查询术语提取模型包列表
 * @returns
 */
export function getAiLexicalConstraintList(params) {
    return defHttp.get({ url: Api.getAiLexicalConstraintList, params });
}


/**
 * 2 分钟超时，与 saipan 后台的机翻超时设置一致。
 * 增加 10 秒钟缓冲时间，以考虑网络延迟、后台处理、消息队列处理...
 * @type {number}
 */
const TERM_TRANSLATE_TIME_OUT = 2 * 60 * 1000 + 10 * 1000;

/**使用机器翻译翻译术语*/
export  function translateTermsWithTM(params) {
    return defHttp.post({url: Api.translateWithMT, params, timeout: TERM_TRANSLATE_TIME_OUT}, { isTransformResponse: false });
}

const ATE_TRANSFORM_TIME_OUT = 60 * 60 * 1000 + 10 * 1000;
/**将术语提取转化为术语库*/
export  function translateATEToGlossary(params) {
    return defHttp.post({url: Api.toGlossary, params, timeout: ATE_TRANSFORM_TIME_OUT });
}

